module.exports = __webpack_public_path__ + "img/2.c93c0be9.png";